// PrismTopContent.jsx
import React, { useEffect } from 'react';
import { 
    ContentWrapper, 
    BulletList, 
    BulletItem, 
    FilterLabel 
} from './style';

const PrismTopContent = (props) => {
  const data1 = props?.prismData?.Heading || null;
  const sampleData = props?.prismData?.PrismOutputSamples?.[0] || null;

  // Clean up HTML tags for the filter string if it's passed as HTML
  const cleanFilterText = typeof data1 === 'string' ? data1.replace(/<\/?p>/g, '') : '';
  
  // Split the filter string at "Filter: " if present, or fallback gracefully
  let filterContent = cleanFilterText;
  if (cleanFilterText.startsWith('Filter:')) {
    filterContent = cleanFilterText.replace('Filter:', '').trim();
  }

  const baseText = `${sampleData?.SampleName} ${sampleData?.SampleValue}`;

  return (
    <ContentWrapper id={`prismInsights__${props?.prismData?.InsightsElementType}__${props?.prismData?.index}`}>
      <div>
        <BulletList>
          {filterContent?.length > 0 && data1 && <BulletItem> <FilterLabel>Filter: </FilterLabel> {filterContent}</BulletItem>}
          {baseText?.length > 0 && sampleData && <BulletItem> {baseText}</BulletItem>}
        </BulletList>
      </div>
    </ContentWrapper>
  );
};

export default PrismTopContent;